const DownArrowIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.31932 4.70859L9.00022.92787c.17235-.177023.16294-.461767-.0082-.63754-.17271-.177396-.45563-.187558-.63004-.00842L5 3.73507 1.63802.28191c-.17441-.179138-.45733-.168975-.63004.008421C.836843.466104.827431.750848.999779.92787L4.68044 4.70835c.00015.00015.00029.0003.00044.00045.00015.00015.00029.0003.00044.00045l.00776.00797c.086.08833.19837.13063.31091.12956.11255.00108.22493-.04123.31093-.12956l.00786-.00807c.00011-.00012.00023-.00023.00034-.00035.00007-.00007.00013-.00014.0002-.00021z" fill="currentColor" stroke="currentColor" strokeWidth=".25"/>
    </svg>
  )
}

export default DownArrowIcon
